export enum Direction {
    North = 'N',
    South = 'S',
    East = 'E',
    West = 'W',
}
